var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"22px"}},[_vm._v("Oops! We seem to have misplaced that one.")])}
var staticRenderFns = []

export { render, staticRenderFns }